import date from "date-and-time";

export const csvFilename = (type: string): string => {
  const today = new Date();
  const formattedDate = date.format(today, "MM/DD/YYYY");
  const fileName = `./${type}_${formattedDate}.csv`;
  return fileName;
};

export const isValidString = (value: any): boolean => {
  return value !== null && value !== undefined && value.trim() !== "";
};

export const replacePlaceholder = (template: string, values: { [key: string]: string }): string => {
  return template ? template.replace(/{\s*(\w+)\s*}/g, (_, key): string => (values[key] ? values[key] : "")) : "";
};
